import { useCanEditResource } from '~/client/src/shared/hooks/useCanEditResource'

import { useResource } from '../context'

/**
 * Whether the current selection contains a resource the current user may not change - the
 * card shows it display-only, so the bulk actions must not reach it either.
 *
 * Checks every selected id against `state.records` for the same reason
 * useSelectionHasProjectLocation scans them: the selection outlives filters, so a hidden
 * row is still in every bulk handler's id list.
 */
export function useSelectionHasLockedRecord(): boolean {
  const {
    state: { records, selectedIds },
    meta: { resourceTypeId },
  } = useResource()
  const canEdit = useCanEditResource(resourceTypeId)

  // Not memoised: canEdit reads company contacts, which load and change without
  // changing any dependency, so the scan runs on every render for MobX to track.
  // Scans the selection, not the records: a selected id with no loaded record (deleted
  // since) cannot be checked, so it counts as locked, as in the provider's assertEditable.
  const recordsById = new Map(records.map(record => [record.id, record]))
  return Array.from(selectedIds).some(id => !canEdit(recordsById.get(id)))
}
